import _extends from "@babel/runtime/helpers/extends";
import { AutocompleteClearIcon, AutocompleteLoadingIcon, AutocompleteSubmitIcon } from "./icons.js";
export function createAutocompleteSearchComponent(_ref) {
  var createElement = _ref.createElement;
  return function AutocompleteSearch(_ref2) {
    var inputProps = _ref2.inputProps,
      onClear = _ref2.onClear,
      query = _ref2.query,
      isSearchStalled = _ref2.isSearchStalled;
    return createElement("form", {
      className: "ais-AutocompleteForm",
      action: "",
      noValidate: true,
      role: "search",
      onSubmit: function onSubmit(e) {
        return e.preventDefault();
      }
    }, createElement("div", {
      className: "ais-AutocompleteInputWrapperPrefix"
    }, createElement("label", {
      className: "ais-AutocompleteLabel",
      "aria-label": "Submit",
      htmlFor: inputProps.id,
      id: "".concat(inputProps.id, "-label")
    }, createElement("button", {
      className: "ais-AutocompleteSubmitButton",
      type: "submit",
      title: "Submit"
    }, createElement(AutocompleteSubmitIcon, {
      createElement: createElement
    }))), createElement("div", {
      className: "ais-AutocompleteLoadingIndicator",
      hidden: !isSearchStalled
    }, createElement(AutocompleteLoadingIcon, {
      createElement: createElement
    }))), createElement("div", {
      className: "ais-AutocompleteInputWrapper"
    }, createElement("input", _extends({
      className: "ais-AutocompleteInput",
      "aria-autocomplete": "both",
      "aria-labelledby": "".concat(inputProps.id, "-label"),
      autoComplete: "off",
      autoCorrect: "off",
      autoCapitalize: "off",
      enterKeyHint: "search",
      spellCheck: "false",
      placeholder: "",
      maxLength: 512,
      type: "search",
      value: query
    }, inputProps))), createElement("div", {
      className: "ais-AutocompleteInputWrapperSuffix"
    }, createElement("button", {
      className: "ais-AutocompleteClearButton",
      type: "reset",
      title: "Clear",
      hidden: query.length === 0 || isSearchStalled,
      onClick: onClear
    }, createElement(AutocompleteClearIcon, {
      createElement: createElement
    }))));
  };
}